// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
__webpack_public_path__ = `${globalThis.crate.assetsBaseUrl}/`;
